import { render, staticRenderFns } from "./deanNullableSwitchFormRow.vue?vue&type=template&id=394331bb&scoped=true"
import script from "./deanNullableSwitchFormRow.vue?vue&type=script&lang=ts"
export * from "./deanNullableSwitchFormRow.vue?vue&type=script&lang=ts"
import style0 from "./deanNullableSwitchFormRow.vue?vue&type=style&index=0&id=394331bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394331bb",
  null
  
)

export default component.exports